export enum LoggingTypes {
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  VERBOSE = 'verbose',
  DEBUG = 'debug',
}
